import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { SparkMetaContentComponent } from './meta-content.component';

@NgModule({
  declarations: [SparkMetaContentComponent],
  imports: [CommonModule, SharedModule],
  exports: [SparkMetaContentComponent]
})
export class SparkMetaContentModule {}
